import type { ComponentProps } from 'react';
import { useEffect, useRef } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router';

import ErrorTemplate from './error-template';

type IProps = Omit<ComponentProps<typeof ErrorTemplate>, 'type'>;

const Oops: React.FC<IProps> = ({ ...props }) => {
  const location = useLocation();
  const { resetBoundary } = useErrorBoundary();
  const errorPathnameRef = useRef<string | null>(null);

  useEffect(() => {
    if (errorPathnameRef.current === null) {
      errorPathnameRef.current = location.pathname;
      return;
    }
    if (errorPathnameRef.current !== location.pathname) {
      errorPathnameRef.current = location.pathname;
      resetBoundary();
    }
  }, [location, resetBoundary]);

  return <ErrorTemplate type="oops" {...props} />;
};

export default Oops;
